import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';

const ExpandedHeaderCell = (props: GridHeaderCellProps) => {
  const { setBudgetPeriods, isBudgetPeriodDirty, budgetPeriodDataWithErrors } =
    useViewBudgetPeriod();
  const isAllExpanded = useMemo(
    () => budgetPeriodDataWithErrors.some((p) => p.expanded),
    [budgetPeriodDataWithErrors]
  );

  const handleExpandClick = useCallback(() => {
    if (!isBudgetPeriodDirty) {
      setBudgetPeriods((prev) =>
        [...prev].map((period) => ({ ...period, expanded: !isAllExpanded }))
      );
    }
  }, [isAllExpanded, isBudgetPeriodDirty, setBudgetPeriods]);

  return (
    <th className="k-header k-hierarchy-cell -ml-0.5 !pb-0.5" style={{ borderBottomWidth: '0px' }}>
      <PopUp
        content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
        show={isBudgetPeriodDirty}
      >
        <ExpandCollapseCell
          expand={isAllExpanded}
          onExpand={handleExpandClick}
          plusIconColor={isBudgetPeriodDirty ? '#aaa' : '#fff'}
          minusIconColor={isBudgetPeriodDirty ? '#aaa' : '#fff'}
        />
      </PopUp>
    </th>
  );
};

export default ExpandedHeaderCell;
